module.exports = __webpack_public_path__ + "static/img/pro1.bec4e8d2.png";